import * as React from 'react';
import { connect } from 'react-redux';
import * as agui from 'arm-gui/dist/controls';
import { i18n, DateFormatter } from 'arm-common';
import DataSourceActions from './DataSourceActions';
import { AppConstants } from '../../constants/AppConstants';
import DocumentiActions from '../documenti/DocumentiActions';

class DataSource extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = "[DataSource.jsx] ";
        this.nuovaDS = this.nuovaDS.bind(this);
    }

    componentDidMount() {
        console.log(this.componentName + "componentDidMount");

        let columns = [
            { field: 'id', title: 'ID', sortable: 'true' },
            { field: 'alias', title: 'Alias', sortable: 'false' },
            { field: 'dataUpdate', title: i18n('ARM_CORE_PRINT.DATA_ULTIMA','Data ultima modifica'), sortable: 'true', formatter: this.dataFormatter },
            { field: 'idUserUpdate', title: i18n('ARM_CORE_PRINT.MODIFICATO','Modificato da'), sortable: 'true' },
            { field: 'info', title: i18n('ARM_CORE_PRINT.SHARED.DETTAGLI', 'Dettagli'), formatter: this.columnDetail }
        ];

        $(this.refs.ListDataSourceTable).bootstrapTable({
            columns: columns,
            idField: "idDataSource",
            sortable: true,
            search: true,
            showColumns: true,
            showExport: true,
            exportDataType: 'all',
            exportTypes: ['csv', 'excel'],
            onClickRow: (row, $element, field) => this.detailsOnClick(row, $element, field),
            // sortOrder: "desc",
            pagination: true,
        });

        this.props.getListaDataSource();
    }

    componentWillReceiveProps(nextProps) {
        console.log(this.componentName + ' componentWillReceiveProps');
        if (nextProps.listaDataSource !== this.props.listaDataSource) {
            console.log("\t rows: " + (nextProps.listaDataSource !== null ? nextProps.listaDataSource.length : "NULL"));
            $(this.refs.ListDataSourceTable).bootstrapTable('load', nextProps.listaDataSource);
        }
    }

    detailsOnClick(row, $element, field) {
        console.log(this.componentName + " deatilsOnClick: " + row.idQuestionario);
        if (field === "info") {
            this.props.changeStatDett(true);
            this.props.getDataSource(row.id);
            this.props.history.push({ pathname: '/dataSource/create', state: { id: row.id, alias: row.alias, lastPath: 'dataSource' } });
        }
    }

    columnDetail(value, row, index) {
        console.log(this.componentName + " columnDetail: " + index);
        let temp;
        temp = "<button class='btn btn-info btn-sm' href='#/dataSource/create'><i class='fas fa-info fa-fw' data-toggle='tooltip' data-placement='top' title='Visualizza'/></button>";
        return temp;
    }

    nuovaDS() {
        this.props.addParametro();
        this.props.history.push('/dataSource/create');
    }

    dataFormatter(value, row, index) {
        return DateFormatter.dataFormatter(value);
    }

    render() {
        console.log(this.componentName + 'render');
        return (
            <div className="mt-3">
                <agui.aCard>
                    <agui.aCardHeader >
                        <agui.LineBar>
                            <agui.LineBarGroup >
                                <h3 className="panel-title">{i18n('ARM_CORE_PRINT.DS.LISTA_DS', 'Lista Data Source')}</h3>
                            </agui.LineBarGroup>
                            <agui.LineBarGroup right={true}>
                                <agui.aButton className="mt-3" bs='primary' icon="fa fa-plus" onClick={() => this.nuovaDS()} inline={true} >{i18n('ARM_CORE_PRINT.SHARED.NUOVA_DATASOURCE', 'Nuovo')}</agui.aButton>
                            </agui.LineBarGroup>
                        </agui.LineBar>
                    </agui.aCardHeader>

                    <agui.aCardBody>
                        {/* <agui.aButton className="mt-3" bs='primary' icon="fa fa-plus" onClick={() => this.props.history.push('/dataSource/create')} inline={true} >{i18n('ARM_CORE_PRINT.SHARED.NUOVA', 'Nuova')}</agui.aButton> */}
                        <table ref="ListDataSourceTable" className={AppConstants.CLASS_BOOSTRAP_TABLE} />
                    </agui.aCardBody>

                </agui.aCard>
            </div>
        );
    }
};

function mapDispatchToProps(dispatch) {
    return {
        getListaDataSource() {
            return dispatch(DataSourceActions.getListaDataSource());
        },
        changeStatDett(statusDett) {
            return dispatch(DataSourceActions.changeStatDett(statusDett));
        },
        getDataSource(idDataSource) {
            return dispatch(DocumentiActions.getDataSource(idDataSource));
        },
        addParametro() {
            return dispatch(DocumentiActions.addParametro());
        }
    }
};

function mapStateToProps(state) {
    return {
        listaDataSource: state.DataSourceReducer.listaDataSource,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DataSource);

